export const selectBaseUrlSelector = (state) => {
    const { alias } = state.p2pSettings;
    const baseUrl = `/event/${alias}/register`;
    return baseUrl;
};

export const selectAllowSubRegistrantToChangeRegRoleBasedOnEnabledTeamsSelector =
    (state) => {
        const { allowSubRegistrantToChangeRegRole, enableTeams } =
            state.p2pSettings;
        const allowSubRegistrantToChangeRegRoleBasedOnEnabledTeams = enableTeams
            ? allowSubRegistrantToChangeRegRole
            : false;
        return allowSubRegistrantToChangeRegRoleBasedOnEnabledTeams;
    };

export const selectRegistrationFeeDisplaySettingsSelector = (p2pSettings) => {
    const { registrationFeeDisplay, registrationFeeDisplayText } = p2pSettings;
    return {
        registrationFeeDisplay,
        registrationFeeDisplayText,
    };
};
